<template>
  <div class="search-container">
    <div class="search-left">
        <el-select v-model="searchForm.whiteType" placeholder="加白类型" clearable class="search-item">
            <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <el-select 
          v-model="searchForm.channelId"
          placeholder="渠道"
          clearable
          class="search-item"
          filterable
          :filter-method="dataFilter"
          @visible-change="handleChannelChange"
        >
            <el-option
              v-for="item in channelShowOptions" :key="item.id" :label="getChannelLabel(item)" :value="item.id"
            />
        </el-select>
        <el-input v-model="searchForm.uid" placeholder="UID" clearable @keyup.enter.native="handleSearch" style="width: 200px; margin-right: 20px;" />
        <el-select v-model="searchForm.status" placeholder="状态" clearable class="search-item">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
    </div>
    <div class="search-right">
      <el-button v-auth="'SCREEN_CONTROL_WHITELIST_SEARCH'" type="primary" @click="handleSearch">搜索</el-button>
      <el-button v-auth="'SCREEN_CONTROL_WHITELIST_ADD'" type="primary" plain @click="handleAdd">新增</el-button>
    </div>
  </div>
</template>

<script>
import { appChannelList } from "@/api/member/index.js";
import { debounce } from "lodash";

export default {
  name: "SearchForm",
  props: {
    searchForm: {
      type: Object,
      default: () => ({
        whiteType: "",
        channelId: "",
        uid: "",
        status: ""
      })
    }
  },
  data() {
    return {
      typeOptions: [
        { label: "UID", value: "2" },
        { label: "渠道", value: "1" }
      ],
      channelOptions: [],
      channelShowOptions: [],
        statusOptions: [
        { label: "启用", value: "1" },
        { label: "禁用", value: "0" }
      ]
    };
  },
  created() {
    this.getChannelOptions();
  },
  methods: {
    getChannelLabel(item) {
      return `[${item.id}] ${item.name}`;
    },
    handleSearch() {
      this.$emit("search", this.searchForm);
    },
    handleAdd() {
      this.$emit("add");
    },
    async getChannelOptions() {
      try {
        const { data } = await appChannelList();
        if (data.code === 200) {
          this.channelOptions = data.data || [];
          // 接口数据量太大，初始只显示前50条数据
          this.channelShowOptions = this.channelOptions.slice(0, 50);
        }
      } catch (error) {
        console.error(error);
      }
    },
    handleChannelChange(visible) {
      if (visible) {
        this.channelShowOptions = this.channelOptions.slice(0, 50);
      } else {
        this.channelShowOptions = [];
      }
    },
    dataFilter: debounce(function(val) {
      if (val) {
        this.channelShowOptions = this.channelOptions.filter(item => this.getChannelLabel(item).toLowerCase().indexOf(val.trim().toLowerCase()) !== -1);
      } else {
        this.channelShowOptions = this.channelOptions.slice(0, 50);
      }
    }, 300)
  }
};
</script>

<style lang="scss" scoped>
.search-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .search-left {
    display: flex;
    align-items: center;
    .search-item {
      width: 200px;
      margin-right: 20px;
    }
  }
}
</style> 